class DataError {
    code;
    message;
    timestamp;
    constructor(response) {
        this.code = response.code;
        this.message = response.message;
        this.timestamp = new Date(response.timestamp);
    }
    toResponse() {
        return {
            code: this.code,
            message: this.message,
            timestamp: this.timestamp.toISOString()
        };
    }
}
export default DataError;
